import script from "./StepSpecific.vue?vue&type=script&setup=true&lang=js"
export * from "./StepSpecific.vue?vue&type=script&setup=true&lang=js"

import "./StepSpecific.vue?vue&type=style&index=0&id=057e5e73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-057e5e73"]])

export default __exports__